module.exports = __webpack_public_path__ + "static/img/static/img/nopermission.d19df5c9.png";